// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import DropdownPickerText from "./DropdownPickerText";
// import SpareCard from "./SpareCard";
// import SparePriceList from "./SparePriceList";
// import { api } from "../api";

// const SpareDsb = ({ role }) => {
//   const [activeTab, setActiveTab] = useState("addSpare");
//   const [image, setImage] = useState(null);
//   const [product, setProduct] = useState("");
//   const [spareName, setSpareName] = useState("");
//   const [spareCondition, setSpareCondition] = useState("New");
//   const [actualPrice, setActualPrice] = useState("");
//   const [offerPrice, setOfferPrice] = useState("");
//   const [offerPercent, setOfferPercent] = useState("");
//   const [description, setDescription] = useState("");
//   const [productList, setProductList] = useState([]);
//   const [cgst, setCgst] = useState("");
//   const [sgst, setSgst] = useState("");
//   const [gstCode, setGstCode] = useState("");
//   const [loadingSpinner, setLoadingSpinner] = useState(false);

//   // Fetch product list
//   const fetchItems = async () => {
//     try {
//       const resPdt = await api.get(`/api/products/`);
//       setProductList(resPdt.data);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     }
//   };

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   // Image Picker for Web
//   const handleImagePick = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImage(file);
//     }
//   };

//   // Upload Spare
//   const handleSpareUpload = async () => {
//     if (!image || !spareName || !product) {
//       alert("Please fill all fields and pick an image.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("image", image);
//     formData.append("product", product);
//     formData.append("spareName", spareName);
//     formData.append("description", description);
//     formData.append("spareCondition", spareCondition);
//     formData.append("actualPrice", actualPrice);
//     formData.append("offerPrice", offerPrice);
//     formData.append("offerPercent", offerPercent);
//     formData.append("cgst", cgst);
//     formData.append("sgst", sgst);
//     formData.append("gstCode", gstCode);

//     try {
//       setLoadingSpinner(true);
//       await api.post(`/api/spares/`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       alert("Spare uploaded successfully!");
//       setImage(null);
//       setProduct("");
//       setSpareName("");
//       setDescription("");
//       setSpareCondition("New");
//       setActualPrice("");
//       setOfferPrice("");
//       setOfferPercent("");
//       setCgst("");
//       setSgst("");
//       setGstCode("");
//       setActiveTab("spareList");
//     } catch (error) {
//       console.error(error);
//       alert("Upload failed");
//     } finally {
//       setLoadingSpinner(false);
//     }
//   };

//   // Offer Price Calculation
//   const handleOffer = (value) => {
//     setOfferPercent(value);
//     const offerAmount = Math.round((actualPrice * value) / 100);
//     const offerPriceFinal = Math.round(actualPrice - offerAmount);
//     setOfferPrice(offerPriceFinal);
//   };

//   return (
//     <div>
//       {!loadingSpinner && (
//         <>
//           {role === "admin" && (
//             <div>
//               <div style={{ display: "flex", gap: "10px", margin: "10px" }}>
//                 <button
//                   onClick={() => setActiveTab("addSpare")}
//                   style={{
//                     background: activeTab === "addSpare" ? "gray" : "purple",
//                     color: "white",
//                     padding: "8px 12px",
//                     borderRadius: "8px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Add Spare
//                 </button>
//                 <button
//                   onClick={() => setActiveTab("spareList")}
//                   style={{
//                     background: activeTab === "spareList" ? "gray" : "purple",
//                     color: "white",
//                     padding: "8px 12px",
//                     borderRadius: "8px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Price List
//                 </button>
//               </div>

//               {activeTab === "addSpare" && (
//                 <div style={{ padding: "10px" }}>
//                   {/* Product Dropdown */}
//                   <div>
//                     <label>Product</label>
//                     <DropdownPicker
//                       options={productList.map((e, i) => ({
//                         label: `${i + 1}. ${e.haProductFn}`,
//                         value: e.haProductFn,
//                       }))}
//                       selectedValue={product}
//                       onSelect={(value) => setProduct(value)}
//                       placeholder="Select Product"
//                     />
//                   </div>

//                   {/* Spare Name */}
//                   <div>
//                     <label>Spare Name</label>
//                     <input
//                       type="text"
//                       value={spareName}
//                       onChange={(e) => setSpareName(e.target.value)}
//                     />
//                   </div>

//                   {/* Spare Description */}
//                   <div>
//                     <label>Description</label>
//                     <input
//                       type="text"
//                       value={description}
//                       onChange={(e) => setDescription(e.target.value)}
//                     />
//                   </div>

//                   {/* Actual Price */}
//                   <div>
//                     <label>Actual Price</label>
//                     <input
//                       type="number"
//                       value={actualPrice}
//                       onChange={(e) => setActualPrice(Number(e.target.value))}
//                     />
//                   </div>

//                   {/* Offer Percent */}
//                   <div>
//                     <label>Offer Percent</label>
//                     <input
//                       type="number"
//                       value={offerPercent}
//                       onChange={(e) => handleOffer(Number(e.target.value))}
//                     />
//                   </div>

//                   {/* Offer Price */}
//                   <div>
//                     <label>Offer Price</label>
//                     <input type="number" value={offerPrice} disabled />
//                   </div>

//                   {/* GST */}
//                   <div>
//                     <label>CGST</label>
//                     <input
//                       type="number"
//                       maxLength={2}
//                       value={cgst}
//                       onChange={(e) => setCgst(Number(e.target.value))}
//                     />
//                     <label>SGST</label>
//                     <input
//                       type="number"
//                       maxLength={2}
//                       value={sgst}
//                       onChange={(e) => setSgst(Number(e.target.value))}
//                     />
//                     <label>HSN/SAC Code</label>
//                     <input
//                       type="number"
//                       maxLength={10}
//                       value={gstCode}
//                       onChange={(e) => setGstCode(Number(e.target.value))}
//                     />
//                   </div>

//                   {/* Condition */}
//                   <div>
//                     <b>Spare Condition:</b>
//                     {["New", "Refurbished", "Used"].map((cond) => (
//                       <button
//                         key={cond}
//                         onClick={() => setSpareCondition(cond)}
//                         style={{
//                           margin: "5px",
//                           fontWeight:
//                             spareCondition === cond ? "bold" : "normal",
//                           color: spareCondition === cond ? "blue" : "gray",
//                         }}
//                       >
//                         {cond}
//                       </button>
//                     ))}
//                   </div>

//                   {/* Image Upload */}
//                   {!image && (
//                     <div>
//                       <input
//                         type="file"
//                         accept="image/*"
//                         onChange={handleImagePick}
//                       />
//                     </div>
//                   )}

//                   {image && (
//                     <div>
//                       <SpareCard
//                         image={URL.createObjectURL(image)}
//                         product={product}
//                         spareName={spareName}
//                         description={description}
//                         actualPrice={actualPrice}
//                         offerPrice={offerPrice}
//                         offerPercent={offerPercent}
//                         spareCondition={spareCondition}
//                         cgst={cgst}
//                         sgst={sgst}
//                         gstCode={gstCode}
//                         code="123"
//                         urlRole="local"
//                       />
//                       <button onClick={handleSpareUpload}>Upload Spare</button>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {activeTab === "spareList" && (
//                 <SparePriceList userRole="admin" />
//               )}
//             </div>
//           )}

//           {role !== "admin" && <SparePriceList userRole={role} />}
//         </>
//       )}

//       {loadingSpinner && (
//         <div style={{ textAlign: "center", padding: "20px" }}>
//           <p>Uploading Image...</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SpareDsb;





import React, { useState, useEffect } from "react";
import axios from "axios";
import { api } from "./localVariableFunction";
import DropdownPickerText from "./DropdownPickerText";
import SpareCard from "./SpareCard";
import SparePriceList from "./SparePriceList";
import "./SpareDsb.css"; // styles

const SpareDsb = ({ role }) => {
  const [activeTab, setActiveTab] = useState("addSpare");
  const [image, setImage] = useState(null);
  const [product, setProduct] = useState("");
  const [spareName, setSpareName] = useState("");
  const [spareCondition, setSpareCondition] = useState("New");
  const [actualPrice, setActualPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [offerPercent, setOfferPercent] = useState("");
  const [description, setDescription] = useState("");
  const [productList, setProductList] = useState([]);
  const [cgst, setCgst] = useState("");
  const [sgst, setSgst] = useState("");
  const [gstCode, setGstCode] = useState("");
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  // Fetch Products
  const fetchItems = async () => {
    try {
      const resPdt = await api.get(`/api/products/`);
      console.log("Product API Response:", resPdt.data); // 🔎 Debug
      setProductList(resPdt.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // Image Picker (Web version: file input)
  const pickImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  // Upload Spare
  const handleSpareUpload = async () => {
    if (!image || !spareName || !product) {
      alert("Please fill all fields and select an image.");
      return;
    }

    const formData = new FormData();
    formData.append("image", image);
    formData.append("product", product);
    formData.append("spareName", spareName);
    formData.append("description", description);
    formData.append("spareCondition", spareCondition);
    formData.append("actualPrice", actualPrice);
    formData.append("offerPrice", offerPrice);
    formData.append("offerPercent", offerPercent);
    formData.append("cgst", cgst);
    formData.append("sgst", sgst);
    formData.append("gstCode", gstCode);

    try {
      setLoadingSpinner(true);
      await api.post(`/api/spares/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Spare uploaded successfully!");
      setImage(null);
      setProduct("");
      setSpareName("");
      setDescription("");
      setSpareCondition("New");
      setActualPrice("");
      setOfferPrice("");
      setOfferPercent("");
      setCgst("");
      setSgst("");
      setGstCode("");
      setActiveTab("spareList");
    } catch (error) {
      console.error(error);
      alert("Upload failed!");
    } finally {
      setLoadingSpinner(false);
    }
  };

  // Offer price calculation
  const handleOffer = (value) => {
    setOfferPercent(value);
    const offerAmount = Math.round((actualPrice * value) / 100);
    setOfferPrice(Math.round(actualPrice - offerAmount));
  };

  return (
    <div>
      {!loadingSpinner ? (
        <>
          {/* Admin Section */}
          {role === "admin" && (
            <div>
              {/* Tabs */}
              <div className="tab-container">
                <button
                  className={activeTab === "addSpare" ? "tab-active" : "tab"}
                  onClick={() => setActiveTab("addSpare")}
                >
                  Add Spare
                </button>
                <button
                  className={activeTab === "spareList" ? "tab-active" : "tab"}
                  onClick={() => setActiveTab("spareList")}
                >
                  Price List
                </button>
              </div>

              {/* Add Spare Form */}
              {activeTab === "addSpare" && (
                <div className="form-container">
                  {/* Product Picker */}
                  <label>
                    Product:
                    <DropdownPickerText
                      options={productList.map((e, i) => ({
                        label:
                          `${i + 1}. ` +
                          (e.haProductFn || e.productName || e.name || "N/A"),
                        value: e.haProductFn || e.productName || e.name || "",
                      }))}
                      selectedValue={product}
                      onSelect={setProduct}
                      placeholder="Select Product"
                    />
                  </label>

                  <label>
                    Spare Name:
                    <input
                      type="text"
                      value={spareName}
                      onChange={(e) => setSpareName(e.target.value)}
                    />
                  </label>

                  <label>
                    Description:
                    <textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </label>

                  <label>
                    Actual Price:
                    <input
                      type="number"
                      value={actualPrice}
                      onChange={(e) => setActualPrice(Number(e.target.value))}
                    />
                  </label>

                  <label>
                    Offer Percent:
                    <input
                      type="number"
                      value={offerPercent}
                      onChange={(e) => handleOffer(Number(e.target.value))}
                    />
                  </label>

                  <label>
                    Offer Price:
                    <input type="number" value={offerPrice} readOnly />
                  </label>

                  <label>
                    CGST:
                    <input
                      type="number"
                      value={cgst}
                      onChange={(e) => setCgst(e.target.value)}
                    />
                  </label>

                  <label>
                    SGST:
                    <input
                      type="number"
                      value={sgst}
                      onChange={(e) => setSgst(e.target.value)}
                    />
                  </label>

                  <label>
                    HSN Code:
                    <input
                      type="text"
                      value={gstCode}
                      onChange={(e) => setGstCode(e.target.value)}
                    />
                  </label>

                  {/* Condition */}
                  <div>
                    <strong>Condition:</strong>
                    {["New", "Refurbished", "Used"].map((cond) => (
                      <label key={cond} style={{ marginLeft: 10 }}>
                        <input
                          type="radio"
                          name="condition"
                          value={cond}
                          checked={spareCondition === cond}
                          onChange={() => setSpareCondition(cond)}
                        />
                        {cond}
                      </label>
                    ))}
                  </div>

                  {/* Image Upload */}
                  <label>
                    Upload Spare Image:
                    <input type="file" accept="image/*" onChange={pickImage} />
                  </label>

                  {image && (
                    <div style={{ margin: "10px 0" }}>
                      <SpareCard
                        image={URL.createObjectURL(image)}
                        product={product}
                        spareName={spareName}
                        description={description}
                        actualPrice={actualPrice}
                        offerPrice={offerPrice}
                        offerPercent={offerPercent}
                        spareCondition={spareCondition}
                        cgst={cgst}
                        sgst={sgst}
                        gstCode={gstCode}
                        code="123"
                        urlRole="local"
                      />
                    </div>
                  )}

                  <button className="btn-upload" onClick={handleSpareUpload}>
                    Upload Spare
                  </button>
                </div>
              )}

              {/* Spare List */}
              {activeTab === "spareList" && <SparePriceList userRole="admin" />}
            </div>
          )}

          {/* Other Roles */}
          {role !== "admin" && <SparePriceList userRole={role} />}
        </>
      ) : (
        <div className="loading">
          <div className="spinner"></div>
          <p>Uploading Image...</p>
        </div>
      )}
    </div>
  );
};

export default SpareDsb;
